/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DebitMastercardServiceRoleProperties } from './DebitMastercardServiceRoleProperties';
import {
    instanceOfDebitMastercardServiceRoleProperties,
    DebitMastercardServiceRolePropertiesFromJSON,
    DebitMastercardServiceRolePropertiesFromJSONTyped,
    DebitMastercardServiceRolePropertiesToJSON,
} from './DebitMastercardServiceRoleProperties';
import type { EbankingServiceRoleProperties } from './EbankingServiceRoleProperties';
import {
    instanceOfEbankingServiceRoleProperties,
    EbankingServiceRolePropertiesFromJSON,
    EbankingServiceRolePropertiesFromJSONTyped,
    EbankingServiceRolePropertiesToJSON,
} from './EbankingServiceRoleProperties';
import type { SafeDepositBoxServiceRoleProperties } from './SafeDepositBoxServiceRoleProperties';
import {
    instanceOfSafeDepositBoxServiceRoleProperties,
    SafeDepositBoxServiceRolePropertiesFromJSON,
    SafeDepositBoxServiceRolePropertiesFromJSONTyped,
    SafeDepositBoxServiceRolePropertiesToJSON,
} from './SafeDepositBoxServiceRoleProperties';

/**
 * @type ProductSpecificServiceRoleProperties
 * 
 * @export
 */
export type ProductSpecificServiceRoleProperties = { propertiesType: 'DEBIT_MASTERCARD' } & DebitMastercardServiceRoleProperties | { propertiesType: 'EBANKING' } & EbankingServiceRoleProperties | { propertiesType: 'SAFE_DEPOSIT_BOX' } & SafeDepositBoxServiceRoleProperties;

export function ProductSpecificServiceRolePropertiesFromJSON(json: any): ProductSpecificServiceRoleProperties {
    return ProductSpecificServiceRolePropertiesFromJSONTyped(json, false);
}

export function ProductSpecificServiceRolePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSpecificServiceRoleProperties {
    if (json == null) {
        return json;
    }
    switch (json['propertiesType']) {
        case 'DEBIT_MASTERCARD':
            return Object.assign({}, DebitMastercardServiceRolePropertiesFromJSONTyped(json, true), { propertiesType: 'DEBIT_MASTERCARD' } as const);
        case 'EBANKING':
            return Object.assign({}, EbankingServiceRolePropertiesFromJSONTyped(json, true), { propertiesType: 'EBANKING' } as const);
        case 'SAFE_DEPOSIT_BOX':
            return Object.assign({}, SafeDepositBoxServiceRolePropertiesFromJSONTyped(json, true), { propertiesType: 'SAFE_DEPOSIT_BOX' } as const);
        default:
            return json;
    }
}

export function ProductSpecificServiceRolePropertiesToJSON(json: any): any {
    return ProductSpecificServiceRolePropertiesToJSONTyped(json, false);
}

export function ProductSpecificServiceRolePropertiesToJSONTyped(value?: ProductSpecificServiceRoleProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['propertiesType']) {
        case 'DEBIT_MASTERCARD':
            return Object.assign({}, DebitMastercardServiceRolePropertiesToJSON(value), { propertiesType: 'DEBIT_MASTERCARD' } as const);
        case 'EBANKING':
            return Object.assign({}, EbankingServiceRolePropertiesToJSON(value), { propertiesType: 'EBANKING' } as const);
        case 'SAFE_DEPOSIT_BOX':
            return Object.assign({}, SafeDepositBoxServiceRolePropertiesToJSON(value), { propertiesType: 'SAFE_DEPOSIT_BOX' } as const);
        default:
            return value;
    }
}

